{
  "UPLOAD_KEY_REQUIRED": "A chave do arquivo é obrigatória.",
  "UPLOAD_KEY_INVALID": "Chave de arquivo inválida.",
  "UPLOAD_KEY_FORBIDDEN": "Chave fora das pastas públicas.",
  "UPLOAD_FILE_REQUIRED": "Arquivo é obrigatório.",
  "UPLOAD_PDF_REQUIRED": "Arquivo PDF é obrigatório.",
  "UPLOAD_FILE_INVALID": "Arquivo inválido. Verifique o tipo e o tamanho do arquivo.",
  "MEDIA_LESSON_NOT_FOUND": "Aula não encontrada.",
  "MEDIA_ATTACHMENT_NOT_FOUND": "Anexo não encontrado.",
  "MEDIA_ATTACHMENT_DELETED": "Anexo excluído.",
  "MEDIA_NOT_FOUND": "Mídia não encontrada.",
  "MEDIA_DELETED": "Mídia excluída.",
  "MEDIA_FILE_TYPE_NOT_ALLOWED": "Tipo de arquivo não permitido.",
  "MEDIA_FILE_TOO_LARGE": "Arquivo muito grande (máx. {{max}}).",
  "MEDIA_VIDEO_TYPE_NOT_ALLOWED": "Tipo de vídeo não permitido.",
  "MEDIA_VIDEO_TOO_LARGE": "Vídeo muito grande (máx. {{max}}).",
  "PAYMENTS_ACCESS_GROUP_REQUIRED": "Grupo de acesso é obrigatório.",
  "PAYMENTS_OFFER_NOT_FOUND": "Oferta não encontrada.",
  "PAYMENTS_PURCHASE_NOT_FOUND": "Compra não encontrada.",
  "PAYMENTS_GATEWAY_NOT_SUPPORTED": "Gateway não suportado.",
  "PAYMENTS_WEBHOOK_UNAVAILABLE": "Webhook {{gateway}} indisponível: segredo não configurado.",
  "PAYMENTS_WEBHOOK_SECRET_INVALID": "Segredo do webhook inválido.",
  "GURU_NOT_CONFIGURED": "Guru não configurado.",
  "GURU_CONNECTION_ESTABLISHED": "Conexão com Guru estabelecida!",
  "GURU_TOKEN_INVALID": "Token inválido ou expirado.",
  "GURU_HTTP_ERROR": "Guru retornou status {{status}}.",
  "GURU_CONNECTION_FAILED": "Erro ao conectar com Guru.",
  "INTEGRATION_NOT_FOUND": "Integração não encontrada.",
  "FREEMIUM_USER_NOT_FOUND": "Usuário não encontrado.",
  "FREEMIUM_ALREADY_AT_TIER": "Você já está neste plano.",
  "FREEMIUM_CANNOT_DOWNGRADE": "Não é possível fazer downgrade de plano.",
  "FREEMIUM_UPGRADE_REQUEST_NOT_FOUND": "Solicitação de upgrade não encontrada.",
  "FREEMIUM_UPGRADE_ALREADY_PROCESSED": "Solicitação de upgrade já processada.",
  "FREEMIUM_UPGRADE_FAILED": "Não foi possível processar o upgrade de plano.",
  "FREEMIUM_UPGRADE_PAYMENT_REQUIRED": "Solicitação de upgrade criada. Pagamento necessário.",
  "FREEMIUM_UPGRADE_PROCESSING": "Solicitação de upgrade criada. Processando...",
  "FREEMIUM_ADMIN_UPGRADE_COMPLETED": "Upgrade administrativo concluído com sucesso.",
  "FREEMIUM_CONTENT_REQUIRES_TIER": "Este conteúdo exige o plano {{tier}}.",
  "FREEMIUM_COURSE_LIMIT_REACHED": "Limite de cursos atingido ({{max}} cursos).",
  "FREEMIUM_LESSON_LIMIT_REACHED": "Limite mensal de aulas atingido ({{max}} aulas).",
  "FREEMIUM_DOWNLOADS_NOT_AVAILABLE": "Downloads não estão disponíveis no seu plano.",
  "FREEMIUM_CERTIFICATES_NOT_AVAILABLE": "Certificados não estão disponíveis no seu plano.",
  "FREEMIUM_AUTH_REQUIRED": "É necessário estar autenticado.",
  "FREEMIUM_ACCESS_CHECK_FAILED": "Não foi possível verificar seu acesso a este conteúdo.",
  "DOMAIN_NOT_FOUND": "Endereço não encontrado.",
  "DOMAIN_IN_USE": "Este endereço já está em uso.",
  "DOMAIN_NO_VERIFICATION_TOKEN": "Este endereço não tem token de verificação.",
  "DOMAIN_PRIMARY_REQUIRES_VERIFIED": "Só um endereço verificado pode ser o principal.",
  "DOMAIN_PRIMARY_REMOVAL_BLOCKED": "Escolha outro endereço como principal antes de remover este.",
  "DOMAIN_INVALID_FORMAT": "Endereço inválido. Use algo como area.suaescola.com.br",
  "DOMAIN_INVALID": "Endereço inválido.",
  "ACCESS_GROUP_NOT_FOUND": "Grupo de acesso não encontrado.",
  "ACCESS_GROUP_HAS_ACTIVE_ENROLLMENTS": "Não é possível excluir o grupo. Existem {{count}} matrículas ativas.",
  "ACCESS_GROUP_DELETED": "Grupo de acesso excluído com sucesso.",
  "ACCESS_GROUP_INTEGRATION_HAS_DEPENDENCIES": "Não é possível excluir: existem compras ou links de afiliado vinculados. Desative a integração em vez de excluir.",
  "ACCESS_GROUP_INTEGRATION_REMOVED": "Integração removida com sucesso.",
  "ACCESS_GROUP_NO_PRODUCTS": "Grupo de acesso não possui produtos.",
  "ENROLLMENT_TARGET_REQUIRED": "Informe um produto ou um grupo de acesso.",
  "ENROLLMENT_ALREADY_EXISTS": "Usuário já matriculado.",
  "ENROLLMENT_NOT_FOUND": "Matrícula não encontrada.",
  "ENROLLMENTS_CREATED": "{{count}} matrícula(s) criada(s) com sucesso.",
  "IMPORT_CSV_REQUIRED": "Arquivo CSV é obrigatório.",
  "IMPORT_EMAIL_REQUIRED": "Email é obrigatório.",
  "IMPORT_USER_NOT_FOUND": "Usuário não encontrado.",
  "WEBHOOK_NOT_FOUND": "Webhook não encontrado.",
  "WEBHOOK_DELETED": "Webhook excluído com sucesso.",
  "WEBHOOK_TEST_SENT": "Webhook de teste enviado.",
  "FEATURE_NOT_IN_PLAN": "Este recurso não está incluído no seu plano. Fale com a Xtreed.",
  "FEATURE_UNKNOWN": "Recurso desconhecido: {{features}}",
  "FEATURE_NOT_AVAILABLE": "Este recurso não está disponível nesta área de membros.",
  "TENANT_HOST_REQUIRED": "Esta rota precisa ser acessada pelo endereço da área de membros.",
  "TENANT_SESSION_UNBOUND": "Sessão sem vínculo com a área de membros. Faça login novamente.",
  "TENANT_SESSION_MISMATCH": "Sessão não pertence a esta área de membros.",
  "ROLES_NOT_AUTHENTICATED": "Usuário não autenticado.",
  "ROLES_INSUFFICIENT_PERMISSION": "Você não tem permissão para acessar este recurso.",
  "SESSION_TOKEN_EXPIRED": "Sua sessão expirou. Entre novamente.",
  "SESSION_TOKEN_INVALID": "Token inválido.",
  "SESSION_UNAUTHORIZED": "Não autorizado."
}
